import React from "react";
import { ToastContainer, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./style/toast.scss";

// NOTE: other placement props are placeholders for now and will be
// finalized in a follow-up pass.
// icon/closeButton are disabled here because every toast is rendered through
// ToastMessage (see src/utils/toast.js), which renders its own icon and close
// button so it can also show the optional complementary/description text.
// autoClose is in ms - 10 seconds so toasts stay visible long enough to read.
const TOAST_AUTO_CLOSE_MS = 10 * 1000;

const AppToastContainer = () => (
  <ToastContainer
    theme="colored"
    icon={false}
    closeButton={false}
    autoClose={TOAST_AUTO_CLOSE_MS}
    position="bottom-right"
    transition={Slide}
    closeOnClick={false}
    draggable={false}
    hideProgressBar
  />
);

export default AppToastContainer;
